import {
  NO_MODE,
  RULE_SIMPLE_SUM,
  RULE_FIVE_SUM,
  RULE_TEN_SUM,
  RULE_FIVE_AND_TEN_SUM,
  MULTIPLICATION,
  DIVISION,
  SQRT,
  CURT,
  SQUARE,
  CUBE,
  DECIMAL_MODE,
  ROOM_TYPES_LEGACY,
  SECTION_TEN,
  SECTION_MIRROR,
  SECTION_UP_TO_FOUR,
  SECTION_UP_TO_FIVE,
  SECTION_UP_TO_SIX,
  SECTION_UP_TO_SEVEN,
  SECTION_UP_TO_EIGHT,
  SECTION_UP_TO_NINE,
  SECTION_DIVISION_REMAINDER,
  SIGN_ADD,
  SIGN_SUB,
  SIGN_MIX,
  NOT_EXCEED_50,
  NOT_EXCEED_100,
  EXCEED_100,
} from '@/modules/Simulators';

export const paramsAvailableTranslate = {
  section: {
    [SECTION_TEN]: 'SECTION_MIRROR',
    [SECTION_MIRROR]: 'SECTION_TEN',
    [SECTION_UP_TO_FOUR]: 'SECTION_UP_TO_FOUR',
    [SECTION_UP_TO_FIVE]: 'SECTION_UP_TO_FIVE',
    [SECTION_UP_TO_SIX]: 'SECTION_UP_TO_SIX',
    [SECTION_UP_TO_SEVEN]: 'SECTION_UP_TO_SEVEN',
    [SECTION_UP_TO_EIGHT]: 'SECTION_UP_TO_EIGHT',
    [SECTION_UP_TO_NINE]: 'SECTION_UP_TO_NINE',
  },
  mode: {
    [NO_MODE]: 'NO_MODE',
    [RULE_SIMPLE_SUM]: 'RULE_SIMPLE_SUM',
    [RULE_FIVE_SUM]: 'RULE_FIVE_SUM',
    [RULE_TEN_SUM]: 'RULE_TEN_SUM',
    [RULE_FIVE_AND_TEN_SUM]: 'RULE_FIVE_AND_TEN_SUM',
    [MULTIPLICATION]: 'MULTIPLICATION',
    [DIVISION]: 'DIVISION',
  },
  animation: {
    1: 'FADING',
    2: 'SLIDE_UP',
    3: 'SLIDE_DOWN',
    4: 'SLIDE_RIGHT',
    5: 'SLIDE_LEFT',
    6: 'BIGGER_FONT',
    7: 'SMALLER_FONT',
    8: 'RANDOM_PLACE',
    9: 'MULTICOLORED_NUMBERS',
    10: 'NO_ANIMATIONS',
  },
  sign: {
    [SIGN_ADD]: '+',
    [SIGN_SUB]: '-',
    [SIGN_MIX]: '+/-',
  },
  bound: {
    [NOT_EXCEED_50]: 'NOT_EXCEED_50',
    [NOT_EXCEED_100]: 'NOT_EXCEED_100',
    [EXCEED_100]: 'EXCEED_100',
  },
  under: {
    1: 1,
    2: 2,
    3: 3,
  },
  over: {
    1: 1,
    2: 2,
    3: 3,
  },
  numbers: {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    9: '9',
  },
  room: {
    roomA: ROOM_TYPES_LEGACY.ANZAN,
    roomB: ROOM_TYPES_LEGACY.COLUMN,
    roomC: ROOM_TYPES_LEGACY.CARDS,
  },
  digits_mode: {
    1: 'MINIMUM_RATE',
    2: 'MAXIMUM_RATE',
  },
  base_side: {
    1: 'BOTH_ARE_SMALLER',
    2: 'BOTH_ARE_BIGGER',
    3: 'OPPOSITE_SIDES',
  },
};

export const paramsAvailable = {
  section: [
    SECTION_UP_TO_FOUR,
    SECTION_UP_TO_FIVE,
    SECTION_UP_TO_SIX,
    SECTION_UP_TO_SEVEN,
    SECTION_UP_TO_EIGHT,
    SECTION_UP_TO_NINE,
    SECTION_TEN,
    SECTION_MIRROR,
  ],
  windows: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  mode: [
    RULE_SIMPLE_SUM,
    RULE_FIVE_SUM,
    RULE_TEN_SUM,
    RULE_FIVE_AND_TEN_SUM,
    MULTIPLICATION,
    DIVISION,
    NO_MODE,
  ],
  interval: [
    0.1,
    0.2,
    0.3,
    0.4,
    0.5,
    0.6,
    0.7,
    0.8,
    0.9,
    1,
    1.1,
    1.2,
    1.3,
    1.4,
    1.5,
    1.6,
    1.7,
    1.8,
    1.9,
    2,
    2.1,
    2.2,
    2.3,
    2.4,
    2.5,
    2.6,
    2.7,
    2.8,
    2.9,
    3,
  ],
  animation: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  sign: [SIGN_ADD, SIGN_SUB, SIGN_MIX],
  steps: [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
  ],
  bound: [NOT_EXCEED_50, NOT_EXCEED_100, EXCEED_100],
  under: [1, 2, 3],
  over: [1, 2, 3],
  simulator: [0, 1, 2, 3, 4],
  numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9],
  amount: [3, 5, 10, 12, 15, 18, 20, 25, 30],
  first_int_available_numbers: [1, 2, 3, 4, 5],
  second_int_available_numbers: [1, 2, 3, 4, 5],
  base: [10, 50, 100, 200, 1000],
  base_side: [1, 2, 3],
  digits_mode: [1, 2],
  room: [
    ROOM_TYPES_LEGACY.ANZAN,
    ROOM_TYPES_LEGACY.COLUMN,
    ROOM_TYPES_LEGACY.CARDS,
  ],
  period: [5, 10, 15],
};

export const formulas = {
  '0': {
    '0': {
      '1': '1 = 5 - 4, 1 = 10 - 9',
      '2': '2 = 5 - 3, 2 = 10 - 8',
      '3': '3 = 5 - 2, 3 = 10 - 7',
      '4': '4 = 5 - 1, 4 = 10 - 6',
      '5': '5 = 10 - 5',
      '6': '6 = 10 - 4, 6 = 1 - 5 + 10',
      '7': '7 = 10 - 3, 7 = 2 - 5 + 10',
      '8': '8 = 10 - 2, 8 = 3 - 5 + 10',
      '9': '9 = 10 - 1, 9 = 4 - 5 + 10',
    },
    '1': {},
    '2': {
      '1': '1 = 5 - 4',
      '2': '2 = 5 - 3',
      '3': '3 = 5 - 2',
      '4': '4 = 5 - 1',
    },
    '3': {
      '1': '1 = 10 - 9',
      '2': '2 = 10 - 8',
      '3': '3 = 10 - 7',
      '4': '4 = 10 - 6',
      '5': '5 = 10 - 5',
      '6': '6 = 10 - 4',
      '7': '7 = 10 - 3',
      '8': '8 = 10 - 2',
      '9': '9 = 10 - 1',
    },
    '4': {
      '6': '6 = 1 - 5 + 10',
      '7': '7 = 2 - 5 + 10',
      '8': '8 = 3 - 5 + 10',
      '9': '9 = 4 - 5 + 10',
    },
  },
  '1': {
    '0': {
      '1': '1 = 5 - 4, 1 = 10 - 9',
      '2': '2 = 5 - 3, 2 = 10 - 8',
      '3': '3 = 5 - 2, 3 = 10 - 7',
      '4': '4 = 5 - 1, 4 = 10 - 6',
      '5': '5 = 10 - 5',
      '6': '6 = 10 - 4, 6 = 1 - 5 + 10',
      '7': '7 = 10 - 3, 7 = 2 - 5 + 10',
      '8': '8 = 10 - 2, 8 = 3 - 5 + 10',
      '9': '9 = 10 - 1, 9 = 4 - 5 + 10',
    },
    '1': {},
    '2': {
      '1': '-1 = -5 + 4',
      '2': '-2 = -5 + 3',
      '3': '-3 = -5 + 2',
      '4': '-4 = -5 + 1',
    },
    '3': {
      '1': '-1 = -10 + 9',
      '2': '-2 = -10 + 8',
      '3': '-3 = -10 + 7',
      '4': '-4 = -10 + 6',
      '5': '-5 = -10 + 5',
      '6': '-6 = -10 + 4',
      '7': '-7 = -10 + 3',
      '8': '-8 = -10 + 2',
      '9': '-9 = -10 + 1',
    },
    '4': {
      '6': '-6 = -1 + 5 - 10',
      '7': '-7 = -2 + 5 - 10',
      '8': '-8 = -3 + 5 - 10',
      '9': '-9 = -4 + 5 - 10',
    },
  },
  '2': {
    '0': {
      '1': '-/+1 = -/+5 +/- 4, -/+1 = -/+10 +/- 9',
      '2': '-/+2 = -/+5 +/- 3, -/+2 = -/+10 +/- 8',
      '3': '-/+3 = -/+5 +/- 2, -/+3 = -/+10 +/- 7',
      '4': '-/+4 = -/+5 +/- 1, -/+4 = -/+10 +/- 6',
      '5': '-/+5 = -/+10 + 5',
      '6': '-/+6 = -/+10 +/- 4, -/+6 = -/+1 +/- 5 -/+ 10',
      '7': '-/+7 = -/+10 +/- 3, -/+7 = -/+2 +/- 5 -/+ 10',
      '8': '-/+8 = -/+10 +/- 2, -/+8 = -/+3 +/- 5 -/+ 10',
      '9': '-/+9 = -/+10 +/- 1, -/+9 = -/+4 +/- 5 -/+ 10',
    },
    '1': {},
    '2': {
      '1': '-/+1 = -/+5 +/- 4',
      '2': '-/+2 = -/+5 +/- 3',
      '3': '-/+3 = -/+5 +/- 2',
      '4': '-/+4 = -/+5 +/- 1',
    },
    '3': {
      '1': '-/+1 = -/+10 +/- 9',
      '2': '-/+2 = -/+10 +/- 8',
      '3': '-/+3 = -/+10 +/- 7',
      '4': '-/+4 = -/+10 +/- 6',
      '5': '-/+5 = -/+10 +/- 5',
      '6': '-/+6 = -/+10 +/- 4',
      '7': '-/+7 = -/+10 +/- 3',
      '8': '-/+8 = -/+10 +/- 2',
      '9': '-/+9 = -/+10 +/- 1',
    },
    '4': {
      '6': '-/+6 = -/+1 +/- 5 -/+ 10',
      '7': '-/+7 = -/+2 +/- 5 -/+ 10',
      '8': '-/+8 = -/+3 +/- 5 -/+ 10',
      '9': '-/+9 = -/+4 +/- 5 -/+ 10',
    },
  },
};

// todo Сделать грид для мобильной версии

export const grid = {
  main: {
    xs: 12,
    sm: 12,
    md: 6,
  },
  sub: {
    xs: 6,
    sm: 4,
  },
  additional: {
    xs: 12,
    md: 3,
  },
};

export const gridStyle = name => {
  switch (name) {
    case 'section':
    case 'numbers':
    case 'mode':
    case 'simulator':
    case 'base':
    case 'digits_mode':
      return 'main';
    default:
      return 'sub';
  }
};

const alph = 'abcdefghijklmnopqrstuwwxyzABCDEFGHIJKLMNOPQRSTUWWXYZ0123456789';

export const randomWord = length => {
  let res = '';

  for (let i = 0; i < length; i += 1) {
    res += alph[Math.ceil(Math.random() * alph.length - 1)];
  }

  return res;
};

export const sum = (mode, args, section) => {
  switch (mode) {
    case MULTIPLICATION:
      return String(args[0] * args[1]);
    case DIVISION:
      return String(
        section === SECTION_DIVISION_REMAINDER
          ? `${Math.floor(args[0] / args[1])} ${args[0] % args[1]}`
          : args[0] / args[1]
      );
    case SQRT:
    case CURT:
      return String(args[0]);
    case SQUARE:
      return String(args[0] ** 2);
    case CUBE:
      return String(args[0] ** 3);
    case DECIMAL_MODE: {
      const total = args.reduce((acc, next) => acc + Number(next), 0);
      const fixed = total.toFixed(2);
      if (fixed.startsWith('-0.')) {
        return `-${fixed.slice(2)}`; // "-0.55" → "-.55"
      }
      return fixed.startsWith('0') ? fixed.slice(1) : fixed; // "0.55" → ".55"
    }
    default:
      return String(args.reduce((acc, next) => acc + Number(next), 0));
  }
};

export const formatExample = (args, mode) => {
  switch (mode) {
    case MULTIPLICATION:
      return [args[0], '*', args[1]];
    case DIVISION:
      return [args[0], '÷', args[1]];
    case SQRT:
      return ['√', args[0] ** 2];
    case CURT:
      return ['∛', args[0] ** 3];
    case SQUARE:
      return [args[0], '²'];
    case CUBE:
      return [args[0], '³'];
    default:
      return args.map((num, i) => (num > 0 && i ? `+${num}` : num));
  }
};
